import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { Uploads3Service } from 'src/app/services/uploads3.service';
import { SaberRolService } from 'src/app/services/saber-rol.service';
import { GetAniosService } from 'src/app/services/get-anios.service';
import { DeductivaService } from 'src/app/services/deductiva.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { FormatoNumberService } from 'src/app/services/formato-number.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { validacionRolService } from 'src/app/services/validacion-rol.service';
import { MESES } from 'src/app/constants/months.const';

@Component({
  selector: 'app-deductiva-d',
  templateUrl: './deductiva-d.component.html',
  styleUrls: ['./deductiva-d.component.css']
})

export class DeductivaDComponent {

  deductiva = {
    FKId_Proyecto: 0,
    DedPen_NomProyecto: '',
    FKId_Direccion: 0,
    DedPen_Mes: '',
    DedPen_Año: '',
    DedPen_Ano: '',
    DedPen_Monto: 0,
    DepPen_VoBo: '',
    DepPen_Observaciones: ''
  }

  selectedFile: File | null = null;
  file: any = {
    file: File,
    url: '',
    type: '',
    name: ''

  };

  urlDocs: string[] = [];
  myDocs: any[] = [];
  nombrePDF: any;
  opE: any;
  control: any;
  proyectos: any[] = [];
  areas: any[] = [];
  token: any;
  retrievedDeductiva: any;

  //Parametros componet viewpdf
  pdfUrl: string = '';
  modalVisible: boolean = false;
  namepdf: string = '';
  //*
  rol: any;
  usuarioId: any;

  anio: string = '';

  showErrorMessageProy: boolean = false;
  showErrorMessageFact: boolean = false;
  showErrorMessageMes: boolean = false;
  showErrorMessageAnio: boolean = false;
  showErrorMessageMonto: boolean = false;

  mensajeValidacionProy: string = '';
  mensajeValidacionFact: string = '';
  mensajeValidacionMes: string = '';
  mensajeValidacionAnio: string = '';
  mensajeValidacionMonto: string = '';

  mensaje: string = 'Campo requerido.';

  validacionRol: string = '';

  iconoMostrar: string = '';
  nameBoton: string = '';

  mostrarBtnDeductiva: boolean = false; 
  validacionCampos: boolean = true;

  mostrarBtnVoBo: boolean = false;

  anios: any;
  meses = MESES;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pagination: PaginationService,
    private UploadService: Uploads3Service,
    private getAniosService:GetAniosService,
    private catalogService: CatalogsService,
    private messagesService: MessagesService,
    private saberRolService: SaberRolService,
    private requestsService: DeductivaService,
    private navigationService: NavigationService,
    private formatoNumberService: FormatoNumberService,
    private validacionBoton:validacionRolService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }

  ngOnInit() {
    this.verificacionUsuario();
    this.obtnerIcono();
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  verificacionUsuario() {
    const { rol, usuarioId, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.usuarioId = usuarioId;
    this.rol = rol;
    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');

    // se obtiene creditor para actualizar
    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedDeductiva = this.sharedService.getDataArray();
      this.deductiva.DedPen_Ano = this.retrievedDeductiva.DedPen_Anio;
      this.cargarDeductiva(this.retrievedDeductiva);
    }

    // se obtienen los proyectos y las areas 
    this.obtenerTodoProyecto();
    this.obtenerTodaArea()
    this.getYears('');
  }

  getYears(seleccion:string){
    this.getAniosService.obtenerAnios().subscribe(
      (data: any) => {
        this.anios = data;
          // Verifica si el año seleccionado ya está en la lista
          if(seleccion!== ''){
            if (this.anios.includes(seleccion)) {
              // Si el año existe, mantenemos el valor
              this.anio = seleccion;
            } else {
                console.warn("El año seleccionado no está en la lista de años disponibles.");
            }
          }

      }, (err) => {
        this.messagesService.showError(err.message);
      });
  }

  obtenerTodoProyecto() {
    this.catalogService.getAllProjects(this.token).subscribe(
      (data: any) => {
        this.proyectos = Object.values(data);
        if (this.rol === 'Administrador') {
          this.proyectos = data
        } else {
          const { proyectosFiltrados } = this.filtrarProyectosService.filtrarProyectos(data, this.usuarioId);
          this.proyectos = proyectosFiltrados;
        }
      }, (error) => {
        this.messagesService.showError(error.message);
      });
  }

  obtenerTodaArea() {
    this.catalogService.getAllArea(this.token).subscribe(
      (data: any) => {
        this.areas = Object.values(data);
      }, (error) => {
        this.messagesService.showError(error.message);
      });
  }

  esAdministrador(): boolean {
    if (this.rol === 'Administrador' && this.deductiva.DepPen_VoBo === 'Aclaracion') {
      return true;
    } else {
      return false;
    }
  }

  async cargarDeductiva(getDeductiva: any) {
    
    this.deductiva.DepPen_VoBo = getDeductiva.DepPen_VoBo;
    this.deductiva.DepPen_Observaciones = getDeductiva.DepPen_Observaciones;
    this.deductiva.FKId_Proyecto = Number(getDeductiva.FKId_Proyecto);
    this.deductiva.DedPen_NomProyecto = getDeductiva.DedPen_NomProyecto;
    this.deductiva.FKId_Direccion = Number(getDeductiva.FKId_Direccion);
    this.deductiva.DedPen_Mes = getDeductiva.DedPen_Mes;
    this.deductiva.DedPen_Monto = getDeductiva.DedPen_Monto;
    
    
    if(getDeductiva.DedPen_Año!==null){
      // this.anio = getDeductiva.DedPen_Año.trim();
      this.deductiva.DedPen_Ano = getDeductiva.DedPen_Año.trim();

      // this.deductiva.DedPen_Anio = getDeductiva.DedPen_Anio.trim();
      this.getYears(getDeductiva.DedPen_Año);
    }

    this.requestsService.getDocs(this.retrievedDeductiva.Id_DedPen, this.token).subscribe(
      (data: any) => {
        this.myDocs = data
      }, (error) => {
        this.messagesService.showError(error.message);
      })
    this.facProImporteAsString();
    this.cargarPDFs()

    this.validacionRol = this.saberRolService.saberRol(getDeductiva, this.usuarioId);

    // Funcion que nos ayuda a validar los botones que se tienen quew mostrar
    this.mostrarBtnDeductiva = this.validacionBoton.validacionBotonEditar(this.rol, this.deductiva.DepPen_VoBo, this.opE,'Dedectiva');
    
    this.mostrarBtnVoBo = this.validacionBoton.validacionBotonVoBo(this.rol, this.deductiva.DepPen_VoBo, this.opE,'Dedectiva');

    // Funcion que nos ayuda a poner disabled los input que se tienen que mostrar
    this.validacionCampos  = this.validacionBoton.validacionCampos(this.rol, this.deductiva.DepPen_VoBo, this.opE,'Dedectiva');

  }

  async validaFormulario(guardar: any, editar: any) {
    
    // this.deductiva.DedPen_Año = this.anio;
    // const proyecto = this.proyectos.find(proyecto => proyecto.Id_Proyecto === String(this.deductiva.FKId_Proyecto));

    // if (proyecto === undefined) {
    //   this.messagesService.showError('El campo proyecto no puede ser vacio');
    // } else {
    //   this.deductiva.DedPen_NomProyecto = proyecto.Pry_Nombre
    // }
    // if (this.deductiva.DedPen_NomProyecto === '' || this.deductiva.DedPen_Monto === 0 || this.deductiva.DedPen_Mes === '' || this.deductiva.DedPen_Año === '') {
    //   this.messagesService.showError('Todos los campos son obligatorios');
    //   return;
    // }

    // Validar los campos vacíos antes de proceder
    if (this.validarCamposVacios()) {
      return; // Si hay campos vacíos, termina la ejecución y no continúa con la edición
    }
    
    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  validarCamposVacios(): boolean {
    const campoNombres: { [key: string]: string } = {
      FKId_Proyecto: 'Proyecto',
      FKId_Direccion: 'Área de facturar',
      DedPen_Mes: 'Mes',
      DedPen_Ano: 'Año',
      DedPen_Monto: 'Monto',
    };
  
    // Lista de campos requeridos y sus validaciones
    const camposNulos: string[] = Object.entries(this.deductiva)
      .filter(([key, value]) => {
        // Valida si el valor es null, string vacío o 0 (según el tipo esperado)
        return (
          campoNombres[key] && // Solo revisa los campos que están en el mapeo
          (value === null || value === '' || value === 0)
        );
      })
      .map(([key]) => campoNombres[key] || key);
  
    if (camposNulos.length > 0) {
      this.messagesService.showError(
        `Los siguientes campos están vacíos o incompletos: ${camposNulos.join(', ')}`
      );
      return true;
    }
  
    return false;
  }
  


  editar() {

    // Continuar con la edición si todos los campos están completos
    this.regresarNumero();

    if (this.rol === 'Administrador' && this.deductiva.DepPen_VoBo === 'VoBo') {
      this.deductiva.DepPen_VoBo = 'VoBo';
    }else if(this.rol === 'Administrador del proyecto' &&  this.deductiva.DepPen_VoBo === 'Aclaracion') { 
      this.deductiva.DepPen_VoBo = 'Pendiente';
    }
  
    this.deductiva.FKId_Direccion = Number(this.deductiva.FKId_Direccion);
    this.deductiva.DedPen_Monto = Number(this.deductiva.DedPen_Monto);
    this.deductiva.FKId_Proyecto = Number(this.deductiva.FKId_Proyecto);

    // this.deductiva.DedPen_Ano = this.anio;
  
    this.requestsService.editdeductiva(this.deductiva, this.retrievedDeductiva.Id_DedPen, this.token).subscribe(
      (res) => {
        this.correctoMensaje(res.message);
      },
      (err) => {
        this.messagesService.showError('No se pudo editar');
      }
    );

  }
  
  guardar() {

    this.regresarNumero();

    this.deductiva.FKId_Direccion = Number(this.deductiva.FKId_Direccion);
    this.deductiva.DedPen_Monto = Number(this.deductiva.DedPen_Monto);
    this.deductiva.FKId_Proyecto = Number(this.deductiva.FKId_Proyecto);
    this.deductiva.DedPen_Año = this.deductiva.DedPen_Ano;
    
    this.requestsService.createdeductiva(this.deductiva, this.token).subscribe(
      (res) => {
        if (this.control === true) {
          this.retrievedDeductiva = res.deductive
          this.saveDocument()
        }
        this.correctoMensaje(res.message);
      }, (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  eliminar() {
    this.requestsService.deletedeductiva(this.retrievedDeductiva.Id_DedPen, this.token).subscribe(
      (res) => {
        this.correctoMensaje(res.message);
      }, (err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  onFileSelected(event: any, folder: any) {
    const input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      this.selectedFile = input.files[0] as File;
      this.saveFile(this.selectedFile, folder);
      this.selectedFile = null;
    } else {
      this.selectedFile = null;
    }
  }

  saveFile(file: any, folder: any) {
    this.UploadService.uploadToS3('deductiva', file, folder).then((urlDoc: any) => {
      this.urlDocs.push(urlDoc);
      if (this.urlDocs.length > 0) {
        this.cargarPDFs();
        this.saveDocument();
      }
    }, (err) => {
      this.messagesService.showError(err);
    });
  }

  cargarPDFs() {
    this.myDocs = [];
    const urls: any[] = [];
    this.urlDocs.forEach(
      (url: any) => {
        const urlObj = new URL(url);
        const pathParts = urlObj.pathname.split('/');
        const nombreArchivo = pathParts[pathParts.length - 1];
        this.nombrePDF = decodeURIComponent(nombreArchivo);

        this.file = {
          file: File,
          url: url,
          type: '',
          name: this.nombrePDF
        }

        this.myDocs.push(this.file)
        urls.push(url)
      });
    if (this.myDocs.length == 0) {
      this.urlDocs = [];
    }
    this.urlDocs = urls;
  }

  deleteFile(index: any, ficha: any, folder: any) {
    this.UploadService.deleteFileS3('deductiva', folder, ficha.DedPenDoc_Nombre).then(
      (res: any) => {
        this.urlDocs.splice(index, 1); // Elimina 1 elemento en la posición 'index'
        this.deleteDoc(ficha);
        this.cargarPDFs();
      }, (err) => {
        this.messagesService.showError(err.Message);
      });
  }

  deleteDoc(ficha: any) {
    this.requestsService.deleteDoc(ficha.Id_DedPenDocumento, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.cargarDeductiva(this.retrievedDeductiva);
      }, (err) => {
        this.messagesService.showError(err.Message);
      }
    )
  }

  saveDocument() {
    if (!this.retrievedDeductiva) {
      this.messagesService.showError('No se ha obtenido una penalización válida.');
      this.control = true;
      this.validaFormulario(true, false);
      return;
    }

    const data = {
      FKId_DedPen: Number(this.retrievedDeductiva.Id_DedPen),
      DedPenDoc_Nombre: this.nombrePDF,
      DedPenDoc_URL: this.urlDocs[0]
    }

    this.requestsService.SaveDocumentDP(data, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message)
        this.urlDocs = []
        if (this.opE === '1') {
          this.cargarDeductiva(this.retrievedDeductiva);
        }
        if (this.opE === '2') {
          // this.router.navigate(['/deductiva']);
        }
      }, (err) => {
        this.messagesService.showError(err.Message);
      })
  }

  cambioEstatus() {
    const data = {
      DepPen_VoBo: "VoBo" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.VoboD(data, this.retrievedDeductiva.Id_DedPen, this.token).subscribe(
      (res) => {
        this.correctoMensaje(res.message);
      }, (err) => {
        this.messagesService.showError('Se tiene problemas para guardar los cambios en estatus');
      }
    )
  }

  comentarios() {
    if (this.deductiva.DepPen_Observaciones === '') {
      this.messagesService.showError('Es necesario colocar algún comentario.');
    } else {
      this.enviarComentario();
    }
  }

  enviarComentario() {
    const data = {
      DepPen_Observaciones: this.deductiva.DepPen_Observaciones, //string
      DepPen_VoBo: "Aclaracion" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.ComentariosD(data, this.retrievedDeductiva.Id_DedPen, this.token).subscribe(
      (res) => {
        this.correctoMensaje(res.message);
      }, (err) => {
        this.messagesService.showError('Se tiene problemas para guardar comentario');
      }
    )
  }

  // Mostrar mensaje que se realizo correctamente la acción y regresar a la pantalla deductiva 
  correctoMensaje(mensaje: string) {
    this.messagesService.showMessage(mensaje);
    this.cancelar();
  }

  // Regresar a la pantalla de deductiva 
  cancelar() {
    this.pagination.setLastAction('back');
    this.router.navigate(['/deductiva']);
  }

  async openModal(document: any) {
    try {
      this.pdfUrl = await this.UploadService.getViewUrl('deductiva', document.FKId_DedPen, document.DedPenDoc_Nombre);
      this.namepdf = document.DedPenDoc_Nombre;
      this.modalVisible = true;
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo abrir el documento.');
    }
  }

  async downloadDocument(document: any) {
    try {
      const url = await this.UploadService.getViewUrl('deductiva', document.FKId_DedPen, document.DedPenDoc_Nombre);
      window.open(url, '_blank');
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo descargar el documento.');
    }
  }

  // Cerrar modal;
  onModalClosed() {
    this.modalVisible = false;
  }

  // regresar a numero 
  regresarNumero() {
    let ingresado = this.deductiva.DedPen_Monto;
    this.deductiva.DedPen_Monto = this.formatoNumberService.regresarNumero(ingresado);
  }

  // funcion que nos permite poner las comas en los digitos
  facProImporteAsString(): any {
    let ingresado = this.deductiva.DedPen_Monto;
    this.deductiva.DedPen_Monto = this.formatoNumberService.facProImporteAsString(ingresado);
  }

  // Método para filtrar caracteres no numéricos y puntos
  filterInput(event: any): void {
    let inputValue = event.target.value;

    // Permitir solo números y un solo punto decimal
    let sanitizedValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    // Verificar si el valor contiene un punto decimal
    if (sanitizedValue.indexOf('.') !== -1) {
      // Dividir el número en partes entera y decimal
      let partes = sanitizedValue.split('.');

      // Limitar la parte decimal a 2 dígitos
      let decimalPart = (partes[1] || '').substring(0, 2);

      // Formatear la parte entera con comas
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Unir la parte entera con la parte decimal
      sanitizedValue = `${partes[0]}.${decimalPart}`;
    } else {
      // Si no hay punto decimal, solo agregar comas a la parte entera
      sanitizedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Actualizar el valor del campo
    event.target.value = sanitizedValue;
    this.facProImporteAsString();
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'proyecto':
        if ((campo.invalid && (campo.dirty || campo.touched)) || campo.value === '0' || campo.value === 0) {
          this.showErrorMessageProy = true;
          this.mensajeValidacionProy = this.mensaje;
        } else {
          this.showErrorMessageProy = false;
        }
        break;
      case 'factura':
        if ((campo.invalid && (campo.dirty || campo.touched)) || campo.value === '0' || campo.value === 0) {
          this.showErrorMessageFact = true;
          this.mensajeValidacionFact = this.mensaje;
        } else {
          this.showErrorMessageFact = false;
        }
        break;
      case 'mes':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageMes = true;
          this.mensajeValidacionMes = this.mensaje;
        } else {
          this.showErrorMessageMes = false;
        }
        break;
      case 'anio':
        if (campo.invalid && (campo.dirty || campo.touched || this.deductiva.DedPen_Año === null)) {
          this.showErrorMessageAnio = true;
          this.mensajeValidacionAnio = this.mensaje;
        } else {
          this.showErrorMessageAnio = false;
        }
        break;
      case 'monto':
        if ((campo.invalid && (campo.dirty || campo.touched)) || this.deductiva.DedPen_Monto === 0) {
          this.showErrorMessageMonto = true;
          this.mensajeValidacionMonto = this.mensaje;
        } else {
          this.showErrorMessageMonto = false;
        }
        break;
    }
  }
}
